export const sideMenuLabels = {
    "ViewTutorial": "view tutorial",
    "HelpAndFeedback": "help and feedback",
    "ChangeLanguage": "change language"
}

export const sideMenu = [
    
    {
        "id": "help and feedback",
        "value": {
            "English": "Help & Feedback",
            "हिंदी": "हेल्प और फीडबैक",
            "ଓଡ଼ିଆ": "ହେଲ୍ପ ଏବଂ ଫୀଡବ୍କ୍",
        },
        "icon": "/Assets/Images/supportCircle.svg",
    },
    {
        "id": "change language",
        "value": {
            "English": "Change Language",
            "हिंदी": "भाषा बदलें",
            "ଓଡ଼ିଆ": "ଟୁଟୋରିଆଲ ଦେଖନ୍ତୁ",
        },
        "icon": "/Assets/Images/globe.svg",
    },
]
export const textSizeConstants = {
    "en": "Change Text size",
    "hi": "टेक्स्ट का साइज  बदलें",
    "or": "ଅକ୍ଷର ର ଆକାର ପରିବର୍ତ୍ତନ କରନ୍ତୁ",
}
export const logoutConstants = {
    "en": "Log out",
    "hi": "लॉग आउट",
    "or": "ଲଗ୍ ଆଉଟ୍",
}

export const viewTutorialLinks = {
    "en": "https://youtu.be/rGDD_X14efs",
    "hi": "https://youtu.be/q9ITUdBZFJc",
    "or": "https://youtu.be/rGDD_X14efs",
}